export default __webpack_public_path__ + "img/6789c85885808536f606ac33e508e26f.jpg";